export class NotificationOptions {
    systemNotificationEmail: boolean;
    systemNotificationSms: boolean;
    customNotificationEmail: boolean;
    customNotificationSms: boolean;
}
